import { cn } from "utils";
import { AgentIdEnum } from "../Find/const";
import NextImage from "../NextImage";
import NormalSearchIcon from "./NormalSearchIcon";

// 创建一个映射表，将类型与对应的图标组件关联起来
const iconMap: any = {
  [AgentIdEnum.CRYPTO]: "chat_crypto",
  [AgentIdEnum.MEMECOINS]: "chat_find",
  [AgentIdEnum.HOT]: "chat_hot",
  [AgentIdEnum.LATEST]: "chat_latest",
  [AgentIdEnum.GHOSTWRITER]: "chat_tweet",
  [AgentIdEnum.MACRO]: "chat_macro",
  [AgentIdEnum.STOCKS]: "chat_stocks",
  [AgentIdEnum.ONCHAIN]: "chat_onChain",
  [AgentIdEnum.JUNKIES]: "chat_fortune",
  [AgentIdEnum.GENERATOR]: "chat_generator",
  [AgentIdEnum.ECOSYSTEM]: "chat_ecosystem",
  [AgentIdEnum.DETECTOR]: "chat_detector",
  [AgentIdEnum.ANALYZER]: "chat_analyzer",
};

const IconWrapper = ({
  sourceType,
  size = 24,
}: {
  sourceType: AgentIdEnum | string | null | undefined;
  size?: number;
}) => {
  if (sourceType === null || sourceType === undefined || sourceType === "") {
    return <NormalSearchIcon />;
  }
  return (
    <div className={cn("w-6 h-6 rounded-lg", size && `w-fit h-fit`)}>
      <NextImage
        src={`/assets/images/${iconMap[sourceType as AgentIdEnum]}.webp`}
        width={size}
        height={size}
      />
    </div>
  );
};
/**
 * 根据 agentId 获取对应的图标组件
 * @param sourceType 可以是 AgentIdEnum、字符串或 null/undefined
 * @returns 对应的图标组件，如果找不到则返回默认图标
 */
export const getAgentIcon = (
  sourceType: AgentIdEnum | string | null | undefined,
  size?: number,
): React.JSX.Element => {
  return <IconWrapper sourceType={sourceType} size={size} />;
};
